import { AES, enc } from 'crypto-js'

// 从环境变量获取加密密钥（需在.env文件中配置REACT_APP_CRYPTO_SECRET）
const SECRET_KEY = import.meta.env.VITE_REACT_APP_CRYPTO_SECRET || 'default_secret_key'

// 加密函数
export const encrypt = (data: string): string => {
  if (!data) return ''
  return AES.encrypt(data, SECRET_KEY).toString()
}

// 解密函数
export const decrypt = (ciphertext: string): string => {
  if (!ciphertext) return ''
  try {
    const bytes = AES.decrypt(ciphertext, SECRET_KEY)
    return bytes.toString(enc.Utf8)
  } catch (error) {
    return ''
  }
}